
<template>
  <div style="height: 10000px">

    <el-container>
      <el-header>
        <el-card style="height:300px;width: 41%;margin:0 auto;">
          <el-descriptions class="margin-top" title="登录信息" :column="3" border>
            <template slot="extra">
              <el-button @click="showActionDialog">执行计划</el-button>

              <!-- 执行方式弹窗 -->
              <el-dialog title="执行方式" :visible.sync="showDialog" width="30%">
                <el-radio-group v-model="actionType">
                  <el-radio label="now">立即执行</el-radio>
                  <el-radio label="schedule">定时执行</el-radio>
                </el-radio-group>

                <!-- 时间选择 -->
                <div v-if="actionType === 'schedule'">
                  <el-time-picker v-model="scheduleTime" :picker-options="timeOptions" placeholder="选择执行时间"
                    class="time-picker" />
                  <div class="time-tip">可选择今日{{ currentTime }}之后或明日任意时间</div>
                </div>

                <div slot="footer">
                  <el-button @click="showDialog = false">取消</el-button>
                  <el-button type="primary" @click="handleConfirm">确定</el-button>
                </div>
              </el-dialog>

              <!-- 倒计时 -->
              <div v-if="remainingTime > 0" class="countdown">
                倒计时: {{ formattedTime }}
              </div>
              <el-button type="primary" v-on:click="GetPlan" size="small">批量搭建</el-button>
              <el-button type="primary" v-on:click="GetRo" size="small">刷新</el-button>
              <el-button type="primary" v-on:click="findIds" size="small">查询</el-button>
            </template>
            <el-descriptions-item>
              <template slot="label">
                <i class="el-icon-user"></i>
                姓名
              </template>
              <div class="block">
                <!--              <el-cascader-->
                <!--                v-model="names"-->
                <!--                :options="name"-->
                <!--                filterable></el-cascader>-->
                <el-select v-model="username" filterable placeholder="请选择">
                  <el-option v-for="(items, i) in listname" :key="i" :value="items.username">
                  </el-option>
                </el-select>
              </div>
            </el-descriptions-item>
            <el-descriptions-item>
              <template slot="label">
                <i class="el-icon-mobile-phone"></i>
                登录二代
              </template>
              微驰
            </el-descriptions-item>
            <el-descriptions-item>
              <template slot="label">
                <i class="el-icon-location-outline"></i>
                账户列表
              </template>

              <el-select v-model="towName" placeholder="请选择">
                <el-option v-for="(items, i) in two" :key="i" :value="items.twoname">
                </el-option>
              </el-select>

            </el-descriptions-item>

            <el-descriptions-item>
              <template slot="label">
                <i class="el-icon-office-building"></i>
                广告主账户列表
              </template>
              <!--            <el-select v-model="idsname" placeholder="请选择">-->
              <!--              <el-option-->
              <!--                v-for="(items,i) in idsList"-->
              <!--                :key="i"-->
              <!--                :value="items.idsname">-->
              <!--              </el-option>-->
              <!--            </el-select>-->
              <el-tag :key="i" v-for="(item, i) in idsList">{{ item.idsname }}</el-tag>

            </el-descriptions-item>
          </el-descriptions>
        </el-card>
      </el-header>
      <el-container>
        <el-aside width="1000px">
          <div style="height:500px;position: absolute;left:200px;top: 320px">
            <el-steps direction="vertical" :active="1">
              <el-step process-status="success" title="创建计划"></el-step>
              <el-step title="创建广告组"></el-step>
              <el-step process-status="success" title="创建广告" description="需要上传图片素材"></el-step>
            </el-steps>
          </div>




        </el-aside>
        <el-container>
          <el-main style="height: 800px;width:1000px">
            <!--          搭建计划代码-->
            <el-card class="box-card1" style="height:60%;">

              <div slot="header" class="clearfix">
                <el-form label-position="right" :model="formLabelAlign">
                  <el-form-item label="计划名称:">
                    <el-input style="width: 200px" v-model="formLabelAlign.name"></el-input>
                  </el-form-item>
                  <el-form-item label="推广目标:" style="margin-top: 20px">
                    <el-cascader v-model="opExtensionType" :options="tgmbArr" @change="opExtensionTypechange"
                      filterable></el-cascader>
                  </el-form-item>
                  <el-form-item label="推广流量:" style="margin-top: 20px">
                    <el-radio-group v-model="extensionFlow" @input="changeextensionFlow">
                      <el-radio-button v-for="item in extensionFlow_group" :key="item.value" :label="item.value">{{
                        item.label
                      }}</el-radio-button>
                    </el-radio-group>
                  </el-form-item>
                  <el-form-item label="流量场景:" style="margin-top: 20px">
                    <el-radio-group v-model="flowScene"  >
                      <template v-if="extensionFlow == 3">
                        <el-radio-button v-for="item in flowScene_group" :key="item.value" :label="item.value">
                          {{ item.label }}
                        </el-radio-button>
                      </template>

                      <!-- extensionFlow == 2 时渲染 flowScene_group2 -->
                      <template v-else-if="extensionFlow == 2">
                        <el-radio-button v-for="item in flowScene_group2" :key="item.value" :label="item.value">
                          {{ item.label }}
                        </el-radio-button>
                      </template>
                    </el-radio-group>
                  </el-form-item>

                  <el-form-item label="计划开关:">
                    <el-switch v-model="flag" active-color="#13ce66" inactive-color="#ff4949">
                    </el-switch>
                  </el-form-item>
                  <el-form-item label="淘宝开关:">
                    <el-switch v-model="taobaoflag" active-color="#13ce66" inactive-color="#ff4949">
                    </el-switch>
                  </el-form-item>

                </el-form>
              </div>

            </el-card>
            <el-card class="box-card2" style="height:40%;">

              <div slot="header" style="margin-left: 0px" class="clearfix">

                <el-form label-position="right" :model="formLabelAlign1">
                  <el-form-item label="*竞价策略:" style="margin-top: 20px">
                    <el-cascader v-model="jjcl" :options="clArr" filterable></el-cascader>
                  </el-form-item>
                  <el-form-item label="日预算(最大转化，最优成本必须填):" style="margin-top: 20px">
                    <el-input style="width: 100px;" v-model="riyusuan"></el-input>元
                  </el-form-item>

                  <el-form-item label="基础出价:" style="margin-top: 20px">
                    <el-input style="width: 100px;" v-model="formLabelAlign1.price"></el-input>元

                  </el-form-item>

                  <el-form-item label="二阶出价:" style="margin-top: 20px">
                    <el-input style="width: 100px;" v-model="formLabelAlign1.ocpxPrice"></el-input>元
                    <el-tag style="margin-left: 20px;"> 是否使用最新广告组出价</el-tag>
                    <el-switch v-model="isoldgroupprice" active-color="#13ce66" inactive-color="#ff4949">
                    </el-switch>
                  </el-form-item>



                  <!--                  <el-form-item label="性别:">-->
                  <!--                    <el-radio-group v-model="sex">-->
                  <!--                      <el-radio-button label="男"></el-radio-button>-->
                  <!--                      <el-radio-button label="女"></el-radio-button>-->
                  <!--                      <el-radio-button label="不限"></el-radio-button>-->
                  <!--                    </el-radio-group>-->
                  <!--                  </el-form-item>-->
                  <!--                  <el-form-item label="年龄(不选即不限):">-->
                  <!--                    <div>-->
                  <!--                      <el-checkbox-group v-model="age">-->
                  <!--                        <el-checkbox-button v-for="(item,i) in ages"  :label="i" :key="i" >{{item.value}}</el-checkbox-button>-->
                  <!--                      </el-checkbox-group>-->
                  <!--                    </div>-->
                  <!--                  </el-form-item>-->
                </el-form>
              </div>

            </el-card>
            <el-card class="box-card3" style="height:5000px;">

              <div slot="header" class="clearfix">
                <el-form label-position="right" :model="formLabelAlign3">









                  <el-form-item label="是否限制推广时段">
                    <!-- 使用el-select来选择是否限制时段 -->
                    <el-select v-model="timeLimit" placeholder="请选择" @change="handleTimeLimitChange">
                      <el-option label="否" :value="0"></el-option>
                      <el-option label="是" :value="1"></el-option>
                    </el-select>
                  </el-form-item>

                  <!-- 如果选择了限制推广时段，显示统一的时间选择器 -->
                  <div v-if="timeLimit === 1">
                    <el-form-item label="设置推广时间：">
                      <el-row :gutter="20">
                        <el-col :span="12" style="width: 150px">
                          <el-time-select style="width: 150px" v-model="startTime" :picker-options="pickerOptions"
                            placeholder="开始时间" @change="validateAndGenerateTimeSet"></el-time-select>
                        </el-col>
                        <el-col :span="12" style="width: 150px">
                          <el-time-select style="width: 150px" v-model="endTime" :picker-options="pickerOptions"
                            placeholder="结束时间" @change="validateAndGenerateTimeSet"></el-time-select>
                        </el-col>
                      </el-row>
                      <span v-if="errorMessage" class="error">{{ errorMessage }}</span>
                    </el-form-item>
                  </div>

                  <!--                  &lt;!&ndash; 实时展示生成的JSON字符串 &ndash;&gt;-->
                  <!--                  <el-alert v-if="timeSet" :title="'当前设置的 timeSet: ' + timeSet" type="success" show-icon></el-alert>-->























                  <el-form-item label="展现形式:">
                    <!--                  <el-select v-model="formLabelAlign3.placeType" placeholder="请选择">-->
                    <!--                    <el-option-->
                    <!--                      v-for="item1 in options4"-->
                    <!--                      :key="item1.value"-->
                    <!--                      :label="item1.label"-->
                    <!--                      :value="item1.value">-->
                    <!--                    </el-option>-->
                    <!--                  </el-select>-->
                    <el-cascader v-model="formLabelAlign3.placeType" :options="options4" @change="placeTypechange"
                      filterable></el-cascader>
                  </el-form-item>
                  <el-form-item label="是否衍生(目前只有横版大图支持衍生视频创意):">
                    <el-switch v-model="yans" active-color="#13ce66" inactive-color="#ff4949">
                    </el-switch>
                  </el-form-item>
                  <el-form-item label="是否快应用dp直达链接(默认否):">
                    <el-switch v-model="kyyzd" active-color="#13ce66" inactive-color="#ff4949">
                    </el-switch>
                  </el-form-item>
                  <el-form-item label="混搭打乱(默认关闭):">
                    <el-switch v-model="daluan" active-color="#13ce66" inactive-color="#ff4949">
                    </el-switch>
                  </el-form-item>
                  <el-form-item label="*按钮文案:" style="margin-top: 20px">
                    <el-cascader v-model="buttonText" :options="optionText" filterable></el-cascader>
                  </el-form-item>
                  <el-form-item label="*产品名:" style="margin-top: 20px">
                    <el-input style="width: 200px;" v-model="formLabelAlign3.productName"></el-input>
                  </el-form-item>
                  <el-form-item :label="'标题：' + titlelentn.length" style="margin-top: 20px">
                    <el-input type="textarea" style="width: 440px;" v-model="titlesString" placeholder="请输入标题（每行一个）"
                      :rows="9" @change="changetitlesString"></el-input>
                  </el-form-item>



                </el-form>
              </div>

            </el-card>
            <!--          图片素材代码-->
            <el-card class="box-cards" style="height:15%;">
              <div slot="header" class="clearfix">
                <span>批量搭建任务进度</span>
              </div>
              <el-row>
                <el-progress style="width: 50%;margin:0 auto;" :text-inside="false" :stroke-width="26" status="success"
                  :percentage="percentages"></el-progress>
              </el-row>
              <!--          <el-dialog :visible.sync="dialogVisible">-->
              <!--            <img width="20%" :src="dialogImageUrl" alt="">-->
              <!--          </el-dialog>-->
            </el-card>
            <el-tabs class="box-card" v-model="updateType">
              <el-tab-pane label="头像素材" name="first">
                <el-card class="box-card" style="height:90%;overflow: auto;">
                  头像数量：{{ txfileList.length }}
                  <div slot="header" class="clearfix" style="display: grid;">
                    <span>素材上传工作区</span>
                    <span>头像（信息流除了（网址-横板大图不需要）其他都需要，联盟竖版大图需要）别的不传</span>
                  </div>
                  <el-row>
                    <el-upload action="#" scoped-slot="text" :multiple="true" :limit="1" list-type="picture-card"
                      :on-preview="handlePictureCardPreview" :auto-upload="false" :file-list="txfileList"
                      :on-change='txonChange' :on-remove="txhandleRemove">
                      <i class="el-icon-plus test"></i>
                    </el-upload>
                    <el-tag>素材上传进度</el-tag>
                    <el-progress style="width: 50%;margin:0 auto;" :text-inside="false" :stroke-width="26"
                      status="success" :percentage="percentage"></el-progress>

                  </el-row>

                  <!-- <el-button type="primary"  @click="clearfile" size="small">一键清除</el-button> -->
                </el-card>

              </el-tab-pane>
              <el-tab-pane label="图片素材" name="second">
                <el-card class="box-card" style="height:90%;overflow: auto;">
                  图片数量：{{ fileList.length }}
                  <div slot="header" class="clearfix" style="display: grid;">
                    <span>素材上传工作区</span>
                    <span>头像（信息流除了（网址-横板大图不需要）其他都需要，联盟竖版大图需要）别的不传</span>
                  </div>
                  <el-row>
                    <el-upload action="#" scoped-slot="text" :multiple="true" list-type="picture-card"
                      :on-preview="handlePictureCardPreview" :auto-upload="false" :file-list="fileList"
                      :on-change='onChange' :on-remove="handleRemove">
                      <i class="el-icon-plus test"></i>
                    </el-upload>
                    <el-tag>素材上传进度</el-tag>
                    <el-progress style="width: 50%;margin:0 auto;" :text-inside="false" :stroke-width="26"
                      status="success" :percentage="percentage"></el-progress>

                  </el-row>

                  <el-button type="primary" @click="clearfile" size="small">一键清除</el-button>
                </el-card>
                <!-- <div>
                  <div slot="header" class="clearfix" style="display: grid;">
                    <span >素材上传工作区</span>
                    <span >头像（信息流都需要，联盟竖版大图需要）别的不传</span>
                  </div>
                  <el-row>
                    <el-upload
                      action="#"
                      scoped-slot="text"
                      :multiple="true"
                      list-type="picture-card"
                      :on-preview="handlePictureCardPreview"
                      :auto-upload="false"

                      :file-list="fileList"
                      :on-change='onChange'
                      :on-remove="handleRemove">
                      <i class="el-icon-plus test"></i>
                    </el-upload>
                    <el-tag>素材上传进度</el-tag>
                    <el-progress style="width: 50%;margin:0 auto;" :text-inside="false" :stroke-width="26"  status="success" :percentage="percentage"></el-progress>

                  </el-row>

                  <el-button type="primary"  @click="clearfile" size="small">一键清除</el-button>
                </div> -->
              </el-tab-pane>
              <el-tab-pane label="视频素材" name="third">
                <el-card class="box-card" style="height:90%;overflow: auto;">
                  <div slot="header" class="clearfix">
                    <span>视频素材上传工作区</span>
                  </div>
                  <el-row>
                    <el-upload action="#" scoped-slot="text" :multiple="true" :on-preview="handlePictureCardPreview2"
                      :auto-upload="false" :file-list="VideofileList" :on-change='onChange2' :on-remove="handleRemove2">
                      <i class="el-icon-plus test"></i>
                    </el-upload>
                    <el-tag>素材上传进度</el-tag>
                    <el-progress style="width: 50%;margin:0 auto;" :text-inside="false" :stroke-width="26"
                      status="success" :percentage="percentage"></el-progress>

                  </el-row>
                  <el-button type="primary" @click="clearfile" size="small">一键清除</el-button>
                </el-card>
              </el-tab-pane>

            </el-tabs>

          </el-main>

        </el-container>
      </el-container>
    </el-container>
    <el-dialog :visible.sync="dialogVisible">
      <img width="50%" :src="dialogImageUrl" alt="">
    </el-dialog>





  </div>
</template>

<script>
import axios from "axios";
import sha1 from 'js-sha1';
import { Base64 } from 'js-base64';
import qs from 'qs';
export default {
  data() {

    const c1 = [{
      id: 1,
      value: '0-18岁'
    },
    {
      id: 2,
      value: '18-24岁'
    },
    {
      id: 3,
      value: '25-29岁'
    },
    {
      id: 4,
      value: '30-34岁'
    },
    {
      id: 5,
      value: '35-49岁'
    },
    {
      id: 6,
      value: '50岁及以上'
    },
    ]
    return {
      
      extensionFlow: 2,
      flowScene: 5,
      taobaoflag: false,
      titlelentn: [],
      newfileList: [],
      newVideofileList: [],
      showDialog: false,
      actionType: 'now',
      scheduleTime: null,
      remainingTime: 0,
      countdownTimer: null,
      currentTime: this.formatTime(new Date()),
      timeLimit: 1, // 默认不限制时段
      startTime: null, // 推广的开始时间
      endTime: null,   // 推广的结束时间
      errorMessage: '', // 错误信息提示
      timeSet: '', // 最终生成的 timeSet JSON 字符串
      pickerOptions: {
        start: '00:00',
        step: '00:30',
        end: '24:00'
      },
      days: ["1", "2", "3", "4", "5", "6", "7"],// 对应周一到周日 ,// 对应周一到周日
      flowScene_group: [
        { value: 12, label: "不限" },
        { value: 7, label: "Banner" },
        { value: 9, label: "插屏" },
        { value: 8, label: "开屏" },
        { value: 10, label: "原生" },
        { value: 11, label: "激励视频" },
      ],
      flowScene_group2: [
        { value: 5, label: "搜索" },
        { value: 6, label: "信息流" },
        
      ],
      extensionFlow_group: [
        { value: 2, label: "自有流量" },
        { value: 3, label: "联盟流量" },
      ],

      riyusuan: 0,
      clArr: [
        {
          value: '0',
          label: '稳定成本'
        },
        {
          value: '1',
          label: '最大转化'
        },
        {
          value: '2',
          label: '最优成本'
        },],
      buttonText: "",
      jjcl: "",
      opExtensionType: 0,
      tgmbArr: [
        {
          value: 1,
          label: '普通网址'
        },

        {
          value: 3,
          label: '快应用推广'
        },],
      ages: c1,
      daluan: false,
      yans: false,
      kyyzd: false,
      flag: false,
      updateType: '',
      listname: [],
      time_list: '',
      timeList: [{
        value: '111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111',
        label: '全天投放'
      },
      {
        value: '000000000011111111111111111111111111111111111111000000000011111111111111111111111111111111111111000000000011111111111111111111111111111111111111000000000011111111111111111111111111111111111111000000000011111111111111111111111111111111111111000000000011111111111111111111111111111111111111000000000011111111111111111111111111111111111111',
        label: '五点'
      },
      {
        value: '000000000000111111111111111111111111111111111111000000000000111111111111111111111111111111111111000000000000111111111111111111111111111111111111000000000000111111111111111111111111111111111111000000000000111111111111111111111111111111111111000000000000111111111111111111111111111111111111000000000000111111111111111111111111111111111111',
        label: '六点'
      },
      {
        value: '000000000000001111111111111111111111111111111111000000000000001111111111111111111111111111111111000000000000001111111111111111111111111111111111000000000000001111111111111111111111111111111111000000000000001111111111111111111111111111111111000000000000001111111111111111111111111111111111000000000000001111111111111111111111111111111111',
        label: '七点'
      },
      {
        value: '000000000000000001111111111111111111111111111111000000000000000001111111111111111111111111111111000000000000000001111111111111111111111111111111000000000000000001111111111111111111111111111111000000000000000001111111111111111111111111111111000000000000000001111111111111111111111111111111000000000000000001111111111111111111111111111111',
        label: '八点半'
      },
      {
        value: '000000000000000000111111111111111111111111111111000000000000000000111111111111111111111111111111000000000000000000111111111111111111111111111111000000000000000000111111111111111111111111111111000000000000000000111111111111111111111111111111000000000000000000111111111111111111111111111111000000000000000000111111111111111111111111111111',
        label: '九点后'
      },
      {
        value: '000000000000000000011111111111111111111111111111000000000000000000011111111111111111111111111111000000000000000000011111111111111111111111111111000000000000000000011111111111111111111111111111000000000000000000011111111111111111111111111111000000000000000000011111111111111111111111111111000000000000000000011111111111111111111111111111',
        label: '九点半'
      },
      {
        value: '000000000000000000001111111111111111111111111111000000000000000000001111111111111111111111111111000000000000000000001111111111111111111111111111000000000000000000001111111111111111111111111111000000000000000000001111111111111111111111111111000000000000000000001111111111111111111111111111000000000000000000001111111111111111111111111111',
        label: '十点'
      },
      {
        value: '000000000000000000000111111111111111111111111111000000000000000000000111111111111111111111111111000000000000000000000111111111111111111111111111000000000000000000000111111111111111111111111111000000000000000000000111111111111111111111111111000000000000000000000111111111111111111111111111000000000000000000000111111111111111111111111111',
        label: '十点半'
      },
      {
        value: '000000000000000000000011111111111111111111111111000000000000000000000011111111111111111111111111000000000000000000000011111111111111111111111111000000000000000000000011111111111111111111111111000000000000000000000011111111111111111111111111000000000000000000000011111111111111111111111111000000000000000000000011111111111111111111111111',
        label: '十一点'
      }, {
        value: '000000000000000000000000000011111111111111111111000000000000000000000000000011111111111111111111000000000000000000000000000011111111111111111111000000000000000000000000000011111111111111111111000000000000000000000000000011111111111111111111000000000000000000000000000011111111111111111111000000000000000000000000000011111111111111111111',
        label: '十四点'
      },
      {
        value: '000000000000000000000000000000001111111111111111000000000000000000000000000000001111111111111111000000000000000000000000000000001111111111111111000000000000000000000000000000001111111111111111000000000000000000000000000000001111111111111111000000000000000000000000000000001111111111111111000000000000000000000000000000001111111111111111',
        label: '十六点'
      },
      {
        value: '000000000000000000000000000000000011111111111111000000000000000000000000000000000011111111111111000000000000000000000000000000000011111111111111000000000000000000000000000000000011111111111111000000000000000000000000000000000011111111111111000000000000000000000000000000000011111111111111000000000000000000000000000000000011111111111111',
        label: '十七点'
      },
      {
        value: '000000000000000000000000000000000000111111111111000000000000000000000000000000000000111111111111000000000000000000000000000000000000111111111111000000000000000000000000000000000000111111111111000000000000000000000000000000000000111111111111000000000000000000000000000000000000111111111111000000000000000000000000000000000000111111111111',
        label: '十八点'
      }],
      names: '',
      idsname: [],
      option1: [{
        value: '1',
        label: '非应用商店'
      },
      {
        value: '2',
        label: '广告联盟'
      }

      ],
      optionText: [
        {
          value: '打开',
          label: '打开'
        },
        {
          value: '下载',
          label: '下载'
        },
        {
          value: '去看看',
          label: '去看看'
        },
        {
          value: '了解详情', label: '了解详情'
        },
        {
          value: '参与活动', label: '参与活动'
        },
        {
          value: '领取优惠', label: '领取优惠'
        },
        {
          value: '立即打开', label: '立即打开'
        },
        {
          value: '立即下载', label: '立即下载'
        },
        {
          value: '立即查看', label: '立即查看'
        },
        {
          value: '立即体验', label: '立即体验'
        },
        {
          value: '立即申请', label: '立即申请'
        },
        {
          value: '立即抢购', label: '立即抢购'
        },

        {
          value: '立即领取', label: '立即领取'
        },

        {
          value: '立即加入', label: '立即加入'
        },

        {
          value: '获取报价', label: '获取报价'
        },

        {
          value: '点击咨询', label: '点击咨询'
        },




      ],

      options3: [{
        value: '4',
        label: '表单提交'
      }, {
        value: '7',
        label: '添加到桌面'
      }, {
        value: '12',
        label: '自定义付费'
      }],
      options4: [
        {
          value: '6',
          label: '信息流',
          children: [{
            value: '1',
            label: '横板大图',
          },
          {
            value: '50',
            label: '竖版大图',
          },
          {
            value: '63',
            label: '竖板视频'
          },
          {
            value: '60',
            label: '横板视频'
          }]
        },
        {
          value: '10',
          label: '联盟原生',
          children: [{
            value: '1',
            label: '横板大图',
          },
          {
            value: '50',
            label: '竖版大图',
          },
          {
            value: '63',
            label: '竖板视频'
          },
          {
            value: '60',
            label: '横板视频'
          }]
        },
        {
          value: '8',
          label: '联盟开屏',
          children: [
            {
              value: '5',
              label: '开屏横图',
            },
            //   {
            //     value: '71',
            //     label: '图标大图',
            //   },
            //   {
            //     value: '63',
            //     label: '竖板视频'
            //   },
            {
              value: '34',
              label: '开屏竖图'
            },
            // {
            //   value: '60',
            //   label: '横版视频'
            // },

          ]
        },
        {
          value: '9',
          label: '插屏',
          children: [
            // {
            //   value: '1',
            //   label: '横版大图',
            // },
            {
              value: '50',
              label: '竖版大图',
            },
            // {
            //   value: '20',
            //   label: '横版小图',
            // },
            // {
            //   value: '30',
            //   label: '横版组图'
            // },
            // {
            //   value: '60',
            //   label: '横版视频'
            // },
            // {
            //   value: '63',
            //   label: '竖版视频'
            // },
            // {
            //   value: '71',
            //   label: '图标大图'
            // },
          ]
        },
      ],
      sex: '不限',
      age: [],
      sexList: [],
      titlesString: '',
      ageIdList: [],
      value: '',
      formLabelAlign: {
        name: '',
        mediaType: '',
      },
      formLabelAlign1: {
        name: '',
        cvType: '',
        ocpxPrice: '',
        price: 1
      },
      isoldgroupprice: false,
      normId: [61, 4, 3],
      formLabelAlign3: {
        placeType: '',
        title: [],
        productName: '',
      },
      percentage: 0,
      percentages: 0,
      fileList: [],
      VideofileList: [],
      age2: '',
      creativeList: [],
      arr: {},
      targetId: '',
      idsList: [
        {
          id: '',
          username: '',
          ids: '',
          twoname: '',
          url: '',
          xiaoshuourl: '',
          token: '',
          idsname: '',
          planId: '',
          groundId: '',
          planName: '',
          pageId: '',
          pageUrl: '',
          ocpcType: '',


        }
      ],
      flagt: 0,
      sex1: '',
      dxid: '',
      addList: [],
      dialogImageUrl: '',
      dialogVisible: false,
      fileCode: [],
      videofileCode: [],
      two: [{
        id: '',
        twoname: '',
      }],
      // towToken:[],
      towName: '',
      username: '',
      txfileList: [],
      txfilecodeList: []
    };
  },
  computed: {
    formattedTime() {
      const pad = n => n.toString().padStart(2, '0')
      return [
        Math.floor(this.remainingTime / 3600),
        Math.floor((this.remainingTime % 3600) / 60),
        this.remainingTime % 60
      ].map(pad).join(':')
    },

    timeOptions() {
      return {
        // 允许选择任意时间
        selectableRange: ['00:00:00 - 23:59:59']
      }
    }

  },
  beforeDestroy() {
    clearInterval(this.countdownTimer)
  },
  methods: {
    changeextensionFlow(string){
      console.log(string);
      if(string==2){
        this.flowScene=5
      }else if(string==3){
        this.flowScene=12
      }
    },
    cleanEmpty(obj) {
      for (let key in obj) {
        const value = obj[key];
        if (
          value === undefined ||
          value === null ||
          value === '' ||
          (Array.isArray(value) && value.length === 0)
        ) {
          delete obj[key];
        }
      }
      return obj;
    },
    opExtensionTypechange(string) {
      console.log(string);
      if (string[0] == 1) {
        this.formLabelAlign1.price = 0.5
      } else if (string[0] == 3) {
        this.formLabelAlign1.price = 1
      }
    },
    placeTypechange(string) {
      console.log(string);
      console.log(this.formLabelAlign3.placeType);
    },
    changetitlesString(string) {
      console.log(string);
      this.titlelentn = string.split('\n')
        .filter(line => line.trim())
    },
    showActionDialog() {
      this.scheduleTime = null
      this.showDialog = true
      this.currentTime = this.formatTime(new Date())
    },

    formatTime(date) {
      return date.toTimeString().slice(0, 5)
    },

    handleConfirm() {
      if (this.actionType === 'schedule' && !this.scheduleTime) {
        return this.$message.warning('请选择执行时间')
      }

      this.showDialog = false
      this.actionType === 'now' ? this.executePlan() : this.startSchedule()
    },

    startSchedule() {
      const now = new Date()
      const selected = new Date(this.scheduleTime)

      const target = new Date(
        now.getFullYear(),
        now.getMonth(),
        now.getDate(),
        selected.getHours(),
        selected.getMinutes()
      )

      if (target < now) target.setDate(target.getDate() + 1)

      const diff = Math.round((target - now) / 1000)
      if (diff <= 0) return this.$message.warning('请选择有效时间')

      // 清除已有定时器
      if (this.countdownTimer) clearInterval(this.countdownTimer)

      this.remainingTime = diff
      this.countdownTimer = setInterval(() => {
        this.remainingTime--

        // 严格等于0时执行
        if (this.remainingTime === 0) {
          clearInterval(this.countdownTimer)
          this.countdownTimer = null
          this.executePlan()
        }
      }, 1000)
    },

    updateCountdown() {
      if (--this.remainingTime <= 0) {
        clearInterval(this.countdownTimer)
        this.executePlan()
      }
    },

    executePlan() {
      // 双重保险清理定时器
      if (this.countdownTimer) {
        clearInterval(this.countdownTimer)
        this.countdownTimer = null
      }

      // 重置状态
      this.remainingTime = 0

      // 执行实际业务逻辑
      console.log('执行主逻辑...')
      this.GetPlan()
    },
    handleTimeLimitChange() {
      if (this.timeLimit === 0) {
        // 如果选择不限制，清空已选择的时间
        this.clearTimeSettings();
      }
    },
    clearTimeSettings() {
      this.startTime = null;
      this.endTime = null;
      this.errorMessage = "";
      this.timeSet = "";
    },
    validateAndGenerateTimeSet() {
      // 只有当开始时间和结束时间都存在时，才进行校验和生成
      if (this.startTime && this.endTime) {
        if (this.startTime >= this.endTime) {
          this.errorMessage = "开始时间不能大于或等于结束时间";
          this.timeSet = ""; // 清空错误情况下的timeSet
        } else {
          this.errorMessage = "";
          this.generateTimeSet(); // 生成JSON
        }
      }
    },
    convertTimeToHalfHours(time) {
      const [hour, minute] = time.split(':').map(Number);
      // 一小时内有2个半小时段，分钟为30时表示该半小时的结束段
      return hour * 2 + (minute === 30 ? 1 : 0);
    },
    generateTimeSet() {
      // 将开始时间和结束时间转化为半小时的编号
      const startHalfHour = this.convertTimeToHalfHours(this.startTime);
      const endHalfHour = this.convertTimeToHalfHours(this.endTime) - 1; // 结束时间不包括最后的半小时

      // 构建每一天的时间段，转换为以半小时为单位的数组
      let timeSetObj = {};
      const halfHourArray = [];
      for (let i = startHalfHour; i <= endHalfHour; i++) {
        halfHourArray.push(i);
      }
      const halfHourString = halfHourArray.join(',');

      // 为每一天构建相同的时间段
      this.days.forEach(day => {
        timeSetObj[day] = halfHourString;
      });

      // 将 JSON 对象转为字符串并显示
      this.timeSet = JSON.stringify(timeSetObj);
    },
    clearfile() {
      // let arr1 =[this.fileList[0]];
      // this.fileList = arr1
      this.VideofileList = []
      this.videofileCode = []
      this.fileList = []
      this.fileList = []
      this.fileCode = []
    },

    shuffle(arr) {
      var l = arr.length
      var index, temp
      while (l > 0) {
        index = Math.floor(Math.random() * l)
        temp = arr[l - 1]
        arr[l - 1] = arr[index]
        arr[index] = temp
        l--
      }
      return arr
    },
    async GetPlan() {
      this.formLabelAlign3.title = this.titlesString.split('\n')
        .filter(line => line.trim())
      this.sexList = [];
      if (this.sex === "女") {
        this.sex1 = '1'
      } else if (this.sex === "男") {
        this.sex1 = '2'
      }

      if (this.age.length === 0) {
        this.age2 = '1,2,3,4,5,6'
      } else {
        this.age2 = this.age.join(",")
      }

      let t = 0;
      console.log(this.idsList)
      console.log(this.formLabelAlign3.placeType[1]);
      if (this.formLabelAlign3.placeType[1] === "1" || this.formLabelAlign3.placeType[1] === "50" || this.formLabelAlign3.placeType[1] === "34" || this.formLabelAlign3.placeType[1] === "5") {
        for (let key in this.idsList) {

          let time1 = parseInt(new Date().getTime()) + '';

          time1 = parseInt(time1 / 1000);
          let sign = sha1(this.idsList[key].apiid + this.idsList[key].apikey + time1);
          let token = Base64.encode(this.idsList[key].ownerid + "," + this.idsList[key].apiid + "," + time1 + "," + sign);
          this.fileCode = []
          let parms = {
            ownerId: this.idsList[key].zzownerid,
            name: this.idsList[key].planName,
            mediaType: this.formLabelAlign.mediaType,
            id: key,
            token: token,
            idsname: this.idsList[key].idsname
          }
          if (this.txfileList.length > 0) {
            await this.txupload(parms)
          }
          await this.upload(parms)
          await this.plan(parms)
          console.log();
          if (this.opExtensionType[0] === 1) {
            await this.queryWebsideId(parms)
          }
          await this.dingxiang(parms)

          let groundData = {
            ownerId: this.idsList[key].zzownerid,
            name: this.idsList[key].planName,
            token: token,
            planId: this.idsList[key].planId,
            adGroupName: this.idsList[key].planName,
            id: key,
            dayLimit: 0,
            extensionFlow: this.extensionFlow,
            extensionType: this.opExtensionType[0],
            flowScene: this.flowScene,
            ocpcOptmType: 2,
            billingType: 5,
            ocpcPrice: this.isoldgroupprice && this.idsList[key].ocpxPrice ? this.idsList[key].ocpxPrice : this.formLabelAlign1.ocpxPrice * 100,
            ocpcType: 6,
            pageId: this.idsList[key].pageId,
            pageType: 7,
            pageUrl: this.opExtensionType[0] === 1 && this.idsList[key].pageUrl !== '' ? this.idsList[key].pageUrl : this.idsList[key].url,
            price: this.formLabelAlign1.price ? (this.formLabelAlign1.price * 100) : 100,
            instantAppUrl: this.opExtensionType[0] == 3 ? this.idsList[key].haplink : (this.opExtensionType[0] === 1 && this.kyyzd ? this.idsList[key].haplink : ''),
            instantAppId: this.opExtensionType[0] == 3 || (this.opExtensionType[0] === 1 && this.kyyzd) ? this.idsList[key].appid : '',
            targetId: this.idsList[key].targetid,
            deepUrl: this.kyyzd ? '' : this.idsList[key].haplink,

          }
          if (this.opExtensionType[0] == 3) {
            console.log(" flowScene: this.flowScene");

            groundData = {
              ownerId: this.idsList[key].zzownerid,
              name: this.idsList[key].planName,
              token: token,
              planId: this.idsList[key].planId,
              adGroupName: this.idsList[key].planName,
              id: key,
              dayLimit: 0,
              extensionFlow: this.extensionFlow,
              extensionType: this.opExtensionType[0],
              flowScene: this.flowScene,
              ocpcOptmType: 2,
              billingType: 5,
              ocpcPrice: this.isoldgroupprice && this.idsList[key].ocpxPrice ? this.idsList[key].ocpxPrice : this.formLabelAlign1.ocpxPrice * 100,
              ocpcType: 6,
              pageId: this.idsList[key].pageId,
              pageType: 7,
              pageUrl: this.opExtensionType[0] === 1 && this.idsList[key].pageUrl !== '' ? this.idsList[key].pageUrl : this.idsList[key].url,
              price: this.formLabelAlign1.price ? (this.formLabelAlign1.price * 100) : 100,
              instantAppUrl: this.opExtensionType[0] == 3 ? this.idsList[key].haplink : (this.opExtensionType[0] === 1 && this.kyyzd ? this.idsList[key].haplink : ''),
              instantAppId: this.opExtensionType[0] == 3 || (this.opExtensionType[0] === 1 && this.kyyzd) ? this.idsList[key].appid : '',
              targetId: this.idsList[key].targetid,
              deepUrl: this.kyyzd ? '' : this.idsList[key].haplink,

            }
          }
          console.log((this.opExtensionType[0] == 1 || this.opExtensionType[0] === 3) && this.kyyzd ? this.idsList[key].haplink : '');
          console.log(groundData);

          // await this.stopPlan(groundData)
          await this.stopPlan(groundData)

          await this.ground(groundData)
          console.log("现在是广告组信息：")
          console.log(this.idsList[key])
          this.addList = [];
          let t = 0;
          // 假设 key 已经在外部循环或上下文中定义
          let placeTypeFirst = this.formLabelAlign3.placeType[0];
          console.log(placeTypeFirst);

          let isPlaceType10 = placeTypeFirst === '10' || placeTypeFirst === '8' || (placeTypeFirst === '6' && this.opExtensionType[0] !== 3);
          console.log(isPlaceType10);
          // if(placeTypeFirst==10&&this.fileList.length!=this.titlelentn.length){
          //   this.$message('图片数量和标题数量不一致');
          //   return
          // }
          let loopLength = this.fileCode.length
          // let loopLength = ((this.opExtensionType[0] === '3') && (this.formLabelAlign3.placeType[0] === "6" && this.formLabelAlign3.placeType[1] === "50")) || (isPlaceType10 && this.formLabelAlign3.placeType[1] === '50' || (this.formLabelAlign3.placeType[1] === "1" && this.formLabelAlign3.placeType[0] === "6" && this.opExtensionType[0] === 3)) ? this.fileCode.length - 1 : this.fileCode.length;
          // console.log(loopLength);
          // if (this.opExtensionType[0] === '1' && this.formLabelAlign3.placeType[0] === '6' && this.formLabelAlign3.placeType[1] === '1') {
          //   loopLength = this.fileCode.length
          // }

          // 如果不是 '10'，获取 brandLogoImgId
          // let brandLogoImgId = null;
          let brandLogoImgId = this.txfilecodeList[0] ? this.txfilecodeList[0] : null;
          // if ((this.opExtensionType[0] != '1' && this.formLabelAlign3.placeType[0] != "10" && this.formLabelAlign3.placeType[1] != "1") || (this.opExtensionType == 3) && (this.formLabelAlign3.placeType[0] == "6" && this.formLabelAlign3.placeType[1] == "50") && this.formLabelAlign3.placeType[1] != "5" || isPlaceType10 && this.fileCode.length > 0 && this.formLabelAlign3.placeType[1] != "5" || (this.formLabelAlign3.placeType[1] == "1" && this.formLabelAlign3.placeType[0] == "6" && this.opExtensionType[0] == 3) && this.formLabelAlign3.placeType[1] != "5") {
          //   brandLogoImgId = this.fileCode[0];
          // }

          console.log(brandLogoImgId);

          this.formLabelAlign3.title = this.titlesString.split('\n')
            .filter(line => line.trim())
          console.log(loopLength);
          for (let code = 0; code < loopLength; code++) {
            t = t + 1;
            let arr = {}; // 使用 let 声明局部变量，避免共享状态

            arr.ownerId = this.idsList[key].zzownerid;
            arr.adPlanId = this.idsList[key].planId;
            arr.adName = this.formLabelAlign.name + Math.round(Math.random() * 1000);
            arr.adGroupId = this.idsList[key].groundId;
            arr.copywriter = this.formLabelAlign3.title[code];
            arr.brandName = this.formLabelAlign3.productName;
            arr.globalSpecId = this.formLabelAlign3.placeType[1];
            arr.adSource = 1;
            arr.clickUrl = this.idsList[key].xiaoshuourl;
            arr.brandLogoImgId = brandLogoImgId;


            arr.imgMatIds = this.fileCode[code];

            if (arr.globalSpecId === "1") {
              this.yans === true ? arr.dynamicCr = 1 : arr.dynamicCr = 0
              // arr.dynamicCr = 1;
            }
            console.log(isPlaceType10)
            // if ((this.opExtensionType[0] == '1' && this.formLabelAlign3.placeType[0] == "10" && this.formLabelAlign3.placeType[1] == "1") || this.formLabelAlign3.placeType[1] == "5" || this.taobaoflag || this.formLabelAlign3.placeType[1] != 50 && (this.formLabelAlign3.placeType[1] == "1" && this.formLabelAlign3.placeType[0] == "6" && this.opExtensionType[0] != "3") || (this.formLabelAlign3.placeType[1] == "1" && this.formLabelAlign3.placeType[0] == "6" && this.opExtensionType[0] != "3")) {
            //   console.log("联盟不传logo");
            //   arr.imgMatIds = this.fileCode[code];
            // }
            // else {
            //   console.log("该传头像");
            //   // 在非 '10' 的情况下，从第二个元素开始
            //   if ((code + 1) <= loopLength) {
            //     console.log(this.fileCode[code + 1]);
            //     arr.imgMatIds = this.fileCode[code + 1];
            //   } else {
            //     console.warn(`索引越界：code + 1 (${code + 1}) >= fileCode.length (${this.fileCode.length})`);
            //     arr.imgMatIds = null; // 或者设置为默认值
            //   }
            //   // 添加 brandLogoImgId 到每个 arr
            //   console.log(brandLogoImgId);
            //   arr.brandLogoImgId = brandLogoImgId;
            // }

            arr.buttonTxt = this.buttonText[0];
            arr = this.cleanEmpty(arr);
            this.addList.push(arr); // 使用 push 方法添加到 addList 中

            console.log("循环列表" + code);
            console.log(this.addList[code]);
          }

          console.log(this.addList)

          let t1 = {
            ownerId: this.idsList[key].zzownerid,
            token: token,
            addList: this.addList,
            name: this.idsList[key].planName,
          }

          await this.guanggao(t1)

          let num = 100 / this.idsList.length;
          this.percentages = num * (Number(key) + 1);
          console.log(this.percentages)



        }
        if (this.percentages === 100) {
          this.$notify({
            title: 'success',
            message: '批量搭建工程全部完成！',
            type: 'success'
          });
        }

      }
      else if (this.formLabelAlign3.placeType[1] === "63" || this.formLabelAlign3.placeType[1] === "60") {

        for (let key in this.idsList) {
          console.log(this.idsList[key])
          let time1 = parseInt(new Date().getTime()) + '';
          console.log(parseInt(time1 / 1000))
          time1 = parseInt(time1 / 1000);
          let sign = sha1(this.idsList[key].apiid + this.idsList[key].apikey + time1);
          let token = Base64.encode(this.idsList[key].ownerid + "," + this.idsList[key].apiid + "," + time1 + "," + sign);
          this.fileCode = []
          let parms = {
            ownerId: this.idsList[key].zzownerid,
            name: this.idsList[key].planName,
            mediaType: this.formLabelAlign.mediaType,
            id: key,
            token: token,
            idsname: this.idsList[key].idsname
          }
          if (this.txfileList.length > 0) {
            await this.txupload(parms)
          }
          await this.upload(parms)
          await this.uploadVideo(parms)
          await this.plan(parms)
          if (this.opExtensionType[0] === 1) {
            await this.queryWebsideId(parms)
          }

          await this.dingxiang(parms)
          //停止计划
          let groundData = {
            ownerId: this.idsList[key].zzownerid,
            name: this.idsList[key].planName,
            token: token,
            planId: this.idsList[key].planId,
            adGroupName: this.idsList[key].planName,
            id: key,
            dayLimit: 0,
            extensionFlow: this.extensionFlow,
            extensionType: this.opExtensionType[0],
            flowScene: this.flowScene,
            ocpcOptmType: 2,
            billingType: 5,
            ocpcPrice: this.isoldgroupprice && this.idsList[key].ocpxPrice ? this.idsList[key].ocpxPrice : this.formLabelAlign1.ocpxPrice * 100,
            ocpcType: 6,
            pageId: this.idsList[key].pageId,
            pageType: 7,
            pageUrl: this.opExtensionType[0] == 1 && (this.idsList[key].pageUrl != '') ? this.idsList[key].pageUrl : this.idsList[key].url,
            price: this.formLabelAlign1.price ? (this.formLabelAlign1.price) : 100,
            instantAppUrl: this.opExtensionType[0] == 1 ? '' : this.idsList[key].url,
            instantAppId: this.opExtensionType[0] == 1 ? '' : this.idsList[key].appid,
            targetId: this.idsList[key].targetid,
            deepUrl: this.idsList[key].haplink,
          }
          if (this.opExtensionType[0] == 3) {
            groundData = {
              ownerId: this.idsList[key].zzownerid,
              name: this.idsList[key].planName,
              token: token,
              planId: this.idsList[key].planId,
              adGroupName: this.idsList[key].planName,
              id: key,
              dayLimit: 0,
              extensionFlow: this.extensionFlow,
              extensionType: this.opExtensionType[0],
              flowScene: this.flowScene,
              ocpcOptmType: 2,
              billingType: 5,
              ocpcPrice: this.isoldgroupprice && this.idsList[key].ocpxPrice ? this.idsList[key].ocpxPrice : this.formLabelAlign1.ocpxPrice * 100,
              ocpcType: 6,
              pageId: this.idsList[key].pageId,
              pageType: 7,
              pageUrl: this.opExtensionType[0] == 1 && (this.idsList[key].pageUrl != '') ? this.idsList[key].pageUrl : this.idsList[key].url,
              price: this.formLabelAlign1.price ? (this.formLabelAlign1.price) : 100,
              instantAppUrl: this.opExtensionType[0] == 1 ? '' : this.idsList[key].url,
              instantAppId: this.opExtensionType[0] == 1 ? '' : this.idsList[key].appid,
              targetId: this.idsList[key].targetid,
              deepUrl: this.idsList[key].haplink,
            }
          }
          // await this.stopPlan(groundData)
          await this.stopPlan(groundData)

          await this.ground(groundData)
          console.log("现在是广告组信息：")
          console.log(this.idsList[key])
          // 假设 key 已经在外部循环或上下文中定义
          this.addList = [];
          let t = 0;


          // let loopLength = isPlaceType10 ? this.fileCode.length : this.fileCode.length - 1;
          let loopLength = this.fileCode.length;


          // if(this.opExtensionType[0] === 1 && this.formLabelAlign3.placeType[0] === '6' &&this.formLabelAlign3.placeType[1] === '1' ){
          //    loopLength  =  this.fileCode.length
          // }

          // 初始化 brandLogoImgId（仅在 placeType[0] != '10' 时）
          // let brandLogoImgId=this.txfilecodeList[0]?this.txfilecodeList[0]:null
          // let brandLogoImgId = null;
          // if (!isPlaceType10 && this.fileCode.length > 0) {
          //   brandLogoImgId = this.fileCode[0];
          // }

          // console.log();

          for (let code = 0; code < this.videofileCode.length; code++) {
            t = t + 1;
            let arr = {}; // 使用 let 声明局部变量，避免共享状态

            // 填充 arr 对象的基础属性
            console.log(this.idsList[key].zzownerid);
            arr.ownerId = this.idsList[key].zzownerid;
            arr.adPlanId = this.idsList[key].planId;
            arr.adName = this.formLabelAlign.name + Math.round(Math.random() * 1000);
            arr.adGroupId = this.idsList[key].groundId;
            // 根据是否为 '10' 来决定 copywriter 的索引
            arr.copywriter = this.formLabelAlign3.title[code];
            // console.log(code);
            console.log(this.formLabelAlign3);
            console.log("arr.copywriterarr.copywriterarr.copywriterarr.copywriter", this.formLabelAlign3.title[code]);
            arr.brandName = this.formLabelAlign3.productName;
            arr.globalSpecId = this.formLabelAlign3.placeType[1];
            arr.adSource = 1;
            arr.clickUrl = this.idsList[key].xiaoshuourl;

            // 根据 globalSpecId 设置 dynamicCr
            if (arr.globalSpecId == "1") {
              this.yans === true ? arr.dynamicCr = 1 : arr.dynamicCr = 0
            }

            // 根据是否为 '10' 来设置 videoImgId 和 videoMatIds
            // if (isPlaceType10) {
            //   console.log("联盟不传logo");
            //   arr.videoImgId = this.fileCode[code];
            //   arr.videoMatIds = this.videofileCode[code];
            // }

            // else {
            //   // 确保 code + 1 不超出 fileCode 的范围
            //   if ((code + 1) < this.fileCode.length) {
            //     arr.videoImgId = this.fileCode[code + 1];
            //   } else {
            //     console.warn(`索引越界：code + 1 (${code + 1}) >= fileCode.length (${this.fileCode.length})`);
            //     arr.videoImgId = null; // 或者设置为默认值
            //   }
            //   arr.videoMatIds = this.videofileCode[code];
            //   // 添加 brandLogoImgId 到每个 arr
            //   arr.brandLogoImgId = brandLogoImgId;
            // }



            // if (isPlaceType10) {
            //   console.log("联盟不传logo");
            arr.videoImgId = this.fileCode[code];
            arr.videoMatIds = this.videofileCode[code];
            // }

            // else {
            // 确保 code + 1 不超出 fileCode 的范围
            // if ((code + 1) < this.fileCode.length) {
            //   arr.videoImgId = this.fileCode[code + 1];
            // } else {
            //   console.warn(`索引越界：code + 1 (${code + 1}) >= fileCode.length (${this.fileCode.length})`);
            //   arr.videoImgId = null; // 或者设置为默认值
            // }
            // arr.videoMatIds = this.videofileCode[code];
            // 添加 brandLogoImgId 到每个 arr
            arr.brandLogoImgId = this.txfilecodeList[0] ? this.txfilecodeList[0] : null;
            // }








            // 设置 buttonTxt
            arr.buttonTxt = this.buttonText[0];

            // 将构建好的 arr 添加到 addList 中
            // this.addList.push(arr);
            this.addList = [...this.addList, arr];

            // 打印当前循环的 arr 对象
            console.log("循环列表" + code);
            console.log(arr);
          }

          console.log(this.addList)

          let t1 = {
            ownerId: this.idsList[key].zzownerid,

            token: token,
            addList: this.addList,
            name: this.idsList[key].planName,
          }
          console.log("addlist广告出出出出出虎虎虎虎虎虎虎虎虎虎虎虎2");

          await this.guanggao(t1)

          let num = 100 / this.idsList.length;
          this.percentages = num * (Number(key) + 1);
          console.log(this.percentages)



        }
        if (this.percentages === 100) {
          this.$notify({
            title: 'success',
            message: '批量搭建工程全部完成！',
            type: 'success'
          });
        }

      }




    },
    ro() {
      this.formLabelAlign3.title = []

    },
    async findIds() {

      this.formLabelAlign3.title = []

      this.idsList = [],
        await axios.post('https://test.nbweiou.cn/api/oppo/get_ids', {
          username: this.username,
          twoname: this.towName
        }).then(async res => {
          this.idsList = res.data;

          const now = new Date();
          const year = now.getFullYear();
          const month = now.getMonth() + 1;
          const pad = (n) => (n < 10 ? '0' + n : n);
          const beginTime = Number(`${year}${pad(month)}01`);
          const endTime = Number(`${year}${pad(month)}${pad(now.getDate())}`);

          // 把所有请求收集到 promises
          const promises = this.idsList.map(async (item, index) => {
            let time1 = Math.floor(Date.now() / 1000);
            let sign = sha1(item.apiid + item.apikey + time1);
            let token = Base64.encode(item.ownerid + "," + item.apiid + "," + time1 + "," + sign);

            const config = {
              headers: {
                Authorization: "Bearer " + token,
                "Content-Type": "application/x-www-form-urlencoded"
              }
            };

            const resp = await axios.post(
              "apis/v3/group/page",
              qs.stringify({
                page: 1,
                limit: 25,
                needStats: 1,
                beginTime,
                endTime,
                extensionTypes: null,
                extensionFlows: null,
                flowScenes: null,
                advertiseTypes: null,
                deleteFlag: 0,
                showStatusSet: null,
                orderByColumn: null,
                insertTime: null,
                asc: "DESC",
                deliveryModes: ""
              }),
              config
            );

            if (resp.data.data.records.length > 0) {
              // console.log(resp.data.data.records);
              // console.log(resp.data.data.records[0]);
              // console.log(resp.data.data.records[0].ocpxPrice);
              // console.log(this.idsList[index]);
              this.idsList[index].ocpxPrice = resp.data.data.records[0].ocpxPrice;
            }
          });

          // 等待所有请求完成
          await Promise.all(promises);

          // 确保 idsList 更新后再打印
          console.log(this.idsList);
        });

    },

    //刷新信息
    async GetRo() {

      console.log(this.formLabelAlign3.placeType[1])
      await axios.post('https://test.nbweiou.cn/api/oppo/get_vivo_user', {
        'username': this.username
      }).then(
        res => {
          this.two = res.data
          // for (let key in res.data){
          //   this.twoName[key]=res.data[key].twoname
          //   this.towToken[key]=res.data[key].token
          // }
        }
      )


      console.log(this.formLabelAlign3.title)


    },
    //停止计划api
    async stopPlan(parms) {
      let flag1 = 0;
      if (this.flag === false) {
        flag1 = 1
      } else {
        flag1 = 0;
      }
      const config = {
        headers: {
          'Authorization': "Bearer " + parms.token,  //这里是关键,设置好Authorization,将定义的token放在后面即可
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      };
      let parmm = {
        ownerId: parms.ownerId,
        planIds: parms.planId,
        status2: flag1
      }
      await axios.post('apis/v3/plan/status', qs.stringify(parmm), config
      ).then(res => {
        console.log(res.data)
      })
    },
    // 查询落地页Url\ID
    async dingxiang(parms) {
      this.flagt = 0;
      let time1 = parseInt(new Date().getTime()) + '';
      let parmm;
      let flag = 0;
      const config = {
        headers: {
          'Authorization': "Bearer " + parms.token,  //这里是关键,设置好Authorization,将定义的token放在后面即可
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      };
      if (this.sex === "不限" && this.age.length != 0) {
        parmm = {
          ownerId: parms.ownerId,
          age: this.age2,
          targetName: "年龄性别" + time1,
          targetDesc: '关于年龄的定向包',
          immutable: '0',
          type: '1',
        }
      } else if (this.age.length === 0 && this.sex != "不限") {
        parmm = {
          ownerId: parms.ownerId,
          sex: this.sex1,
          targetName: "年龄性别" + time1,
          targetDesc: '关于年龄的定向包',
          immutable: '0',
          type: '1',
        }
      } else if (this.age.length === 0 && this.sex === "不限") {
        this.flagt = 1
      } else {
        parmm = {
          ownerId: parms.ownerId,
          age: this.age2,
          sex: this.sex1,
          targetName: "年龄性别" + time1,
          targetDesc: '关于年龄的定向包',
          immutable: '0',
          type: '1',
        }
      }



      if (this.flagt === 0) {
        await axios.post('apis/v2/communal/target/add', qs.stringify(parmm, { allowDots: true }), config
        ).then(res => {
          console.log("aaaaaaaaaaaaaaaaaaa---------------aaaaaaaaaaaaaaaaaaaa")
          console.log(res.data.data.targetId)
          this.targetId = res.data.data.targetId

        })
      }
    },
    // 查询落地页Url\ID
    async queryWebsideId(parms) {
      const config = {
        headers: {
          'Authorization': "Bearer " + parms.token,  //这里是关键,设置好Authorization,将定义的token放在后面即可
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      };
      let parmm = {
        ownerId: parms.ownerId,
        pageType: 7,
      }
      await axios.post('apis/v2/communal/ad/sparkPageNew/list', qs.stringify(parmm), config
      ).then(res => {
        if (res.data.data.length == 0) {
          this.idsList[parms.id].pageId = 0,
            this.idsList[parms.id].pageUrl = this.idsList[parms.id].url,
            this.idsList[parms.id].ocpcType = 0
          return
        }
        console.log(res.data.data[0].pageId)
        this.idsList[parms.id].pageId = res.data.data[0].pageId,
          this.idsList[parms.id].pageUrl = res.data.data[0].pageUrl,
          this.idsList[parms.id].ocpcType = res.data.data[0].ocpcType
      })
    },
    //获取最新广告组
    latestgroup() {
      console.log(this.idsList);
    },


    // 搭建计划api
    async plan(parms) {
      let time1 = parseInt(new Date().getTime()) + '';

      const config = {
        headers: {
          'Authorization': "Bearer " + parms.token,  //这里是关键,设置好Authorization,将定义的token放在后面即可
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      };
      var parmm = {}
      if (this.jjcl == 0) {
        parmm = {
          ownerId: parms.ownerId,
          extensionType: this.opExtensionType[0],
          // dayBudget:155500,
          planName: parms.name + time1 + '_' + this.formLabelAlign.name,
          dayLimit: 0,
          deliveryMode: this.jjcl[0]
        }
      } else {
        parmm = {
          ownerId: parms.ownerId,
          extensionType: this.opExtensionType[0],
          // dayBudget:155500,
          planName: parms.name + time1 + '_' + this.formLabelAlign.name,
          dayLimit: 1,
          dayBudget: this.riyusuan * 100,
          deliveryMode: this.jjcl[0]
        }
      }

      await axios.post('apis/v3/plan/add', qs.stringify(parmm), config
      ).then(res => {
        this.idsList[parms.id].planId = res.data.data.planId
      })



    },
    // 搭建广告组api
    async ground(parms) {
      console.log(parms.targetid)
      let parmm;
      let time1 = parseInt(new Date().getTime()) + '';
      console.log('浏览场景是' + this.formLabelAlign3.placeType[0])
      const config = {
        headers: {
          'Authorization': "Bearer " + parms.token,  //这里是关键,设置好Authorization,将定义的token放在后面即可
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      };

      // 原生
      console.log("opExtensionType的值为（1为普通网址：3为快应用）" + this.opExtensionType[0])
      console.log(this.formLabelAlign3.placeType[0])
      console.log(this.formLabelAlign3.placeType[0] === '8')
      if (this.formLabelAlign3.placeType[0] === '10') {
        if (this.opExtensionType[0] == 1) {
          parmm = {
            ownerId: parms.ownerId,
            planId: parms.planId,
            adGroupName: parms.name + time1 + '_' + this.formLabelAlign.name,
            billingType: 5,
            dayLimit: 0,
            extensionFlow: this.extensionFlow,
            extensionType: 1,
            flowScene: this.flowScene,
            ocpcOptmType: 0,
            defaultSecondStage: 1,
            deepOcpcPrice: 0,
            deepOcpcType: 0,
            ocpcPrice: parms.ocpcPrice,
            ocpcType: this.taobaoflag ? 14 : 6,
            pageId: parms.pageId,
            pageType: 7,
            pageUrl: parms.pageUrl,
            price: this.formLabelAlign1.price ? (this.formLabelAlign1.price * 100) : 50,
            instantAppId: parms.instantAppId,
            instantAppUrl: parms.instantAppUrl,
            deepUrl: parms.deepUrl,
            targetId: parms.targetId
          }
          // 判断是否限制推广时段
          if (this.timeLimit == 1) {
            parmm.timeLimit = 1;
            parmm.timeSet = this.timeSet;  // 假设 this.timeSet 是已经生成好的 JSON 格式的推广时段
          } else {
            parmm.timeLimit = 0;
          }
        } else if (this.opExtensionType[0] == 3) {
          parmm = {
            ownerId: parms.ownerId,
            planId: parms.planId,
            adGroupName: parms.name + time1 + '_' + this.formLabelAlign.name,
            billingType: 5,
            dayLimit: 0,
            extensionFlow: this.this.extensionFlow,
            extensionType: 3,
            instantAppId: parms.instantAppId,
            instantAppUrl: parms.instantAppUrl,
            flowScene: this.flowScene,
            ocpcOptmType: 0,
            defaultSecondStage: 1,
            deepOcpcPrice: 0,
            deepOcpcType: 0,
            ocpcPrice: parms.ocpcPrice,
            ocpcType: 32,
            pageType: 0,
            pageUrl: parms.pageUrl,
            price: this.formLabelAlign1.price * 100,
            targetId: this.targetId,
            linkDeskFlag: 0

          }
          // 判断是否限制推广时段
          if (this.timeLimit == 1) {
            parmm.timeLimit = 1;
            parmm.timeSet = this.timeSet;  // 假设 this.timeSet 是已经生成好的 JSON 格式的推广时段
          } else {
            parmm.timeLimit = 0;
          }
        }

      }
      else if (this.formLabelAlign3.placeType[0] === '8') {

        if (this.opExtensionType[0] == 1) {
          parmm = {
            ownerId: parms.ownerId,
            planId: parms.planId,
            adGroupName: parms.name + time1 + '_' + this.formLabelAlign.name,
            billingType: 5,
            dayLimit: 0,
            extensionFlow: this.extensionFlow,
            extensionType: 1,
            flowScene: this.flowScene,
            ocpcOptmType: 0,
            defaultSecondStage: 1,
            deepOcpcPrice: 0,
            deepOcpcType: 0,
            ocpcPrice: parms.ocpcPrice,
            ocpcType: 6,
            pageId: parms.pageId,
            pageType: 7,
            pageUrl: parms.pageUrl,
            price: this.formLabelAlign1.price * 100,
            instantAppId: parms.instantAppId,
            instantAppUrl: parms.instantAppUrl,
            targetId: parms.targetId
          }
          // 判断是否限制推广时段
          if (this.timeLimit == 1) {
            parmm.timeLimit = 1;
            parmm.timeSet = this.timeSet;  // 假设 this.timeSet 是已经生成好的 JSON 格式的推广时段
          } else {
            parmm.timeLimit = 0;
          }
        }
        else if (this.opExtensionType[0] === 3) {
          parmm = {
            ownerId: parms.ownerId,
            planId: parms.planId,
            adGroupName: parms.name + time1 + '_' + this.formLabelAlign.name,
            billingType: 5,
            dayLimit: 0,
            extensionFlow: this.extensionFlow,
            extensionType: 3,
            instantAppId: parms.instantAppId,
            instantAppUrl: parms.instantAppUrl,
            flowScene: this.flowScene,
            ocpcOptmType: 0,
            defaultSecondStage: 1,
            deepOcpcPrice: 0,
            deepOcpcType: 0,
            ocpcPrice: parms.ocpcPrice,
            ocpcType: 32,
            pageType: 0,
            pageUrl: parms.pageUrl,
            price: this.formLabelAlign1.price * 100,
            targetId: this.targetId,
            linkDeskFlag: 0

          }
          // 判断是否限制推广时段
          if (this.timeLimit == 1) {
            parmm.timeLimit = 1;
            parmm.timeSet = this.timeSet;  // 假设 this.timeSet 是已经生成好的 JSON 格式的推广时段
          } else {
            parmm.timeLimit = 0;
          }
        }

      }
      else if (this.formLabelAlign3.placeType[0] === '9') {
        if (this.opExtensionType[0] == 1) {
          parmm = {
            ownerId: parms.ownerId,
            planId: parms.planId,
            adGroupName: parms.name + time1 + '_' + this.formLabelAlign.name,
            billingType: 5,
            dayLimit: 0,
            extensionFlow: this.extensionFlow,
            extensionType: 1,
            flowScene: this.flowScene,
            ocpcOptmType: 0,
            defaultSecondStage: 1,
            deepOcpcPrice: 0,
            deepOcpcType: 0,
            ocpcPrice: parms.ocpcPrice,
            ocpcType: 6,
            pageId: parms.pageId,
            pageType: 7,
            pageUrl: parms.pageUrl,
            price: this.formLabelAlign1.price * 100,
            instantAppId: parms.instantAppId,
            instantAppUrl: parms.instantAppUrl,
            targetId: parms.targetId
          }
          // 判断是否限制推广时段
          if (this.timeLimit == 1) {
            parmm.timeLimit = 1;
            parmm.timeSet = this.timeSet;  // 假设 this.timeSet 是已经生成好的 JSON 格式的推广时段
          } else {
            parmm.timeLimit = 0;
          }
        } else if (this.opExtensionType[0] == 3) {
          parmm = {
            ownerId: parms.ownerId,
            planId: parms.planId,
            adGroupName: parms.name + time1 + '_' + this.formLabelAlign.name,
            billingType: 5,
            dayLimit: 0,
            extensionFlow: this.extensionFlow,
            extensionType: 3,
            instantAppId: parms.instantAppId,
            instantAppUrl: parms.instantAppUrl,
            flowScene: this.flowScene,
            ocpcOptmType: 0,
            defaultSecondStage: 1,
            deepOcpcPrice: 0,
            deepOcpcType: 0,
            ocpcPrice: parms.ocpcPrice,
            ocpcType: 32,
            pageType: 0,
            pageUrl: parms.pageUrl,
            price: this.formLabelAlign1.price * 100,
            targetId: this.targetId,
            linkDeskFlag: 0

          }
          // 判断是否限制推广时段
          if (this.timeLimit == 1) {
            parmm.timeLimit = 1;
            parmm.timeSet = this.timeSet;  // 假设 this.timeSet 是已经生成好的 JSON 格式的推广时段
          } else {
            parmm.timeLimit = 0;
          }
        }

      }
      else {
        // 信息流
        if (this.opExtensionType[0] == 1) {
          parmm = {
            ownerId: parms.ownerId,
            planId: parms.planId,
            adGroupName: parms.name + time1 + '_' + this.formLabelAlign.name,
            billingType: 5,
            dayLimit: 0,
            extensionFlow: this.extensionFlow,
            extensionType: 1,
            flowScene: this.flowScene,
            ocpcOptmType: 0,
            defaultSecondStage: 1,
            deepOcpcPrice: 0,
            deepOcpcType: 0,
            ocpcPrice: parms.ocpcPrice,
            ocpcType: 6,
            pageId: parms.pageId,
            pageType: 7,
            pageUrl: parms.pageUrl,
            price: this.formLabelAlign1.price * 100,
            instantAppId: parms.instantAppId,
            instantAppUrl: parms.instantAppUrl,
            targetId: parms.targetId
          }
          // 判断是否限制推广时段
          if (this.timeLimit == 1) {
            parmm.timeLimit = 1;
            parmm.timeSet = this.timeSet;  // 假设 this.timeSet 是已经生成好的 JSON 格式的推广时段
          } else {
            parmm.timeLimit = 0;
          }
        }
        else {
          parmm = {
            ownerId: parms.ownerId,
            planId: parms.planId,
            adGroupName: parms.name + time1 + '_' + this.formLabelAlign.name,
            billingType: 5,
            dayLimit: 0,
            extensionFlow: this.extensionFlow,
            extensionType: 3,
            instantAppId: parms.instantAppId,
            instantAppUrl: parms.deepUrl,
            flowScene: this.flowScene,
            ocpcOptmType: 0,
            defaultSecondStage: 1,
            deepOcpcPrice: 0,
            deepOcpcType: 0,
            ocpcPrice: parms.ocpcPrice,
            ocpcType: 32,
            pageType: 0,
            pageUrl: parms.pageUrl,
            price: this.formLabelAlign1.price * 100,
            targetId: parms.targetId,
            linkDeskFlag: 0
          }
          // 判断是否限制推广时段
          if (this.timeLimit == 1) {
            parmm.timeLimit = 1;
            parmm.timeSet = this.timeSet;  // 假设 this.timeSet 是已经生成好的 JSON 格式的推广时段
          } else {
            parmm.timeLimit = 0;
          }
        }


      }

      console.log(parmm)
      parmm = this.cleanEmpty(parmm)
      await axios.post('apis/v3/group/add', qs.stringify(parmm), config
      ).then(res => {
        // console.log(?)
        console.log(res.data.data)

        console.log(res.data.data.adGroupId)
        this.idsList[parms.id].groundId = res.data.data.adGroupId

      })
    },
    // 创建广告api
    async guanggao(parms) {
      const config = {
        headers: {
          'Authorization': "Bearer " + parms.token,  //这里是关键,设置好Authorization,将定义的token放在后面即可
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      };
      console.log(parms)
      console.log(parms.addList)
      let map = new Map;
      let add = {
        'ownerId': parms.ownerId,
        'addList': parms.addList
      }


      map.set("addList", add)
      // console.log(addList[0]);
      console.log("-----------------")
      console.log("ddddddddddddddddddddddddddddddddddddddddddd");
      console.log(qs.stringify(add))
      await axios.post('apis/v3/ad/batch', qs.stringify(add, { allowDots: true }), config
      ).then(res => {

        console.log(res.data);
        //广告组ID

      })
    },
    //获取时间方法
    //获取当前日期函数
    getNowFormatDate() {
      let date = new Date(),
        year = date.getFullYear(), //获取完整的年份(4位)
        month = date.getMonth() + 1, //获取当前月份(0-11,0代表1月)
        strDate = date.getDate() // 获取当前日(1-31)
      if (month < 10) month = `0${month}` // 如果月份是个位数，在前面补0
      if (strDate < 10) strDate = `0${strDate}` // 如果日是个位数，在前面补0

      return `${year}-${month}-${strDate}`
    },
    getFixedFirstWithRandomLodash(arr, randomCount) {
      if (!arr.length || randomCount <= 0) return [];
      return [arr[0], ..._.sampleSize(arr.slice(1), randomCount)];
    },
    // 横板大图不保留头像
    hbdtgetPureRandomByCountLodash(arr, randomCount) {
      if (!arr.length || randomCount <= 0) return [];
      // 边界条件：数组为空或 randomCount 无效时返回空数组
      return _.sampleSize(arr, randomCount);
      // 直接使用 _.sampleSize 从整个数组中随机抽取指定数量
    },
    getRandomItems(arr, count) {
      // 创建副本避免修改原数组
      const temp = [...arr];
      const result = [];

      // 随机选取直到达到指定数量
      while (result.length < count && temp.length > 0) {
        const randomIndex = Math.floor(Math.random() * temp.length);
        result.push(temp.splice(randomIndex, 1)[0]);
      }

      return result;
    },
    async txupload(ps) {

      for (let i = 0; i < this.txfileList.length; i++) {
        let formData = new FormData()
        const config = {
          headers: {
            'Authorization': "Bearer " + ps.token,  //这里是关键,设置好Authorization,将定义的token放在后面即可
            'Content-Type': 'application/x-www-form-urlencoded'
          }
        };
        formData.append('ownerId', ps.ownerId)
        formData.append('files', this.txfileList[0].raw)
        formData.append('matSpecId', this.formLabelAlign3.placeType[1])
        let map = new Map;
        map.set('files', formData)
        map.set('matSpecId', 1)
        // key
        await axios.post('apis/v3/creative/material/communal/upload',
          formData, config).then(res => {
            // console.log(res.data.data.id);
            if (res.data.msg != "") {
              this.$message({ message: '头像上传失败问题是：' + res.data.msg, type: 'error' });
            }
            this.txfilecodeList[0] = res.data.data.id;

          })
      }

      this.$notify({
        title: 'success',
        message: '素材上传成功',
        type: 'success'
      });


    },
    //图片上传api
    async upload(ps) {

      let num = 100 / this.fileList.length;
      if (this.daluan) {
        if (this.opExtensionType[0] === 1 && this.formLabelAlign3.placeType[0] === '6' && this.formLabelAlign3.placeType[1] === '1') {
          // 计算非空行数量
          let filenumber = this.titlesString.split('\n')
            .filter(line => line.trim());

          // 调用新方法，完全随机抽取
          let res = this.hbdtgetPureRandomByCountLodash(
            this.fileList,
            filenumber.length
          );

          this.newfileList = res;
        } else {
          let filenumber = this.titlesString.split('\n')
            .filter(line => line.trim())
          let res = this.getFixedFirstWithRandomLodash(this.fileList, filenumber.length);
          // console.log("asdadsdgasgdygaysgdgyasgdgy"+res);
          this.newfileList = res
        }
      } else {
        this.newfileList = this.fileList
      }


      for (let i = 0; i < this.newfileList.length; i++) {
        let formData = new FormData()
        const config = {
          headers: {
            'Authorization': "Bearer " + ps.token,  //这里是关键,设置好Authorization,将定义的token放在后面即可
            'Content-Type': 'application/x-www-form-urlencoded'
          }
        };
        formData.append('ownerId', ps.ownerId)
        formData.append('files', this.newfileList[i].raw)
        formData.append('matSpecId', this.formLabelAlign3.placeType[1])
        let map = new Map;
        map.set('files', formData)
        map.set('matSpecId', 1)
        // key
        await axios.post('apis/v3/creative/material/communal/upload',
          formData, config).then(res => {
            // console.log(res.data.data.id);
            if (res.data.msg != "") {
              this.$message({ message: '第' + (i + 1) + '张图片出现了问题，问题是：' + res.data.msg, type: 'error' });
            }
            this.fileCode[i] = res.data.data.id;
            this.percentage = num * (i + 1);
            // // console.log(res.data.data.fileCode);
            // // console.log(res.data.data.fileFullPath);
          })
      }
      if (this.percentage === 100) {
        this.$notify({
          title: 'success',
          message: '素材上传成功',
          type: 'success'
        });
      }

      console.log(this.fileCode);//这里输出的是一个空的formData对象，因为formData是加密处理的我们看不到其内容，但的的确确添加进去了。

    },

    async uploadVideo(ps) {

      let num = 100 / this.VideofileList.length;

      if (this.daluan) {
        let filenumber = this.titlesString.split('\n')
          .filter(line => line.trim())
        console.log("ppppppppppppppppppppppppppppppppppppppppppppp", filenumber.length);
        let res = this.getRandomItems(this.VideofileList, filenumber.length);
        // console.log("asdadsdgasgdygaysgdgyasgdgy"+res);
        this.newVideofileList = res
      } else {
        this.newVideofileList = this.VideofileList
      }


      console.log("dddddddddddddddddddddpppppppppp", this.newVideofileList.length);
      for (let i = 0; i < this.newVideofileList.length; i++) {
        let formData = new FormData()
        const config = {
          headers: {
            'Authorization': "Bearer " + ps.token,  //这里是关键,设置好Authorization,将定义的token放在后面即可
            'Content-Type': 'application/x-www-form-urlencoded'
          }
        };
        formData.append('ownerId', ps.ownerId)
        formData.append('files', this.newVideofileList[i].raw)
        formData.append('matSpecId', this.formLabelAlign3.placeType[1])
        console.log(formData);
        let map = new Map;
        map.set('files', formData)
        map.set('matSpecId', 1)
        await axios.post('apis/v3/creative/material/communal/upload',
          formData, config).then(res => {
            if (res.data.msg != "") {
              this.$message({ message: '第' + (i + 1) + '个视频出现了问题，问题是：' + res.data.msg, type: 'error' });
            }
            console.log(res.data);


            this.videofileCode[i] = res.data.data.id;
            this.percentage = num * (i + 1);
            // // console.log(res.data.data.fileCode);
            // // console.log(res.data.data.fileFullPath);
          })
      }
      if (this.percentage === 100) {
        this.$notify({
          title: 'success',
          message: '素材上传成功',
          type: 'success'
        });
      }

      console.log(this.videofileCode);//这里输出的是一个空的formData对象，因为formData是加密处理的我们看不到其内容，但的的确确添加进去了。

    },

    change() {
      console.log(this.towName)
    },
    txonChange(a, fileList) {
      this.txfileList = [a];

    },
    onChange(a, fileList) {
      console.log(this.fileList)
      this.fileList = fileList;
    },
    handleRemove(file, fileList) {
      console.log(file, fileList);
      const tp = this.fileList.findIndex(function (item) {
        return item.uid === file.uid;
      });
      if (tp !== -1) {
        this.fileList.splice(tp, 1);
        this.fileCode.slice(tp, 1)
      }
    },
    txhandleRemove(file, fileList) {
      console.log(file, fileList);
      const tp = this.fileList.findIndex(function (item) {
        return item.uid === file.uid;
      });
      if (tp !== -1) {
        this.fileList.splice(tp, 1);
        this.fileCode.slice(tp, 1)
      }
    },
    handlePictureCardPreview(file) {
      console.log(file)
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    onChange2(a, fileList) {
      console.log(this.fileList)
      this.VideofileList = fileList;
    },
    handleRemove2(file, fileList) {
      console.log(file, fileList);
    },
    handlePictureCardPreview2(file) {


    },


  },
  created() {
    //自动加载indexs方法
    axios.get('https://test.nbweiou.cn/api/oppo/find_list_name', {
    }).then(
      res => {
        this.listname = res.data
        console.log(this.listname)
      }
    )

    this.latestgroup()
  }
}
</script>
<style scoped>
.text {
  font-size: 14px;
}

.item {
  margin-bottom: 18px;
}

.clearfix:before,
.clearfix:after {
  display: table;
  content: "";
}

.clearfix:after {
  clear: both
}


.box-card1 {
  position: absolute;
  top: 370px !important;
  bottom: 0;
  left: 0;
  right: 0;
  margin: 0 auto;
  width: 40% !important;
}

.box-card2 {
  position: absolute !important;
  top: 820px !important;
  bottom: 0;
  left: 0;
  right: 0;
  margin: 0 auto;
  width: 40% !important;
  /* height: 900px; */
}

.box-card3 {
  position: absolute !important;
  top: 1200px !important;
  bottom: 0;
  left: 0px;
  right: 0px;
  margin: 0 auto;
  width: 40%;
}

.box-card {
  /*position: absolute;*/
  /*top: 1000px;*/
  /*bottom: 0;*/
  /*!*left: 1000px;*!*/
  /*right: 50px;*/
  /*!*margin:0 auto;*!*/
  position: fixed;
  bottom: 35px;
  right: 30px;
  width: 25%;
}

.box-cards {
  /*position: absolute;*/
  /*top: 1000px;*/
  /*bottom: 0;*/
  /*!*left: 1000px;*!*/
  /*right: 50px;*/
  /*!*margin:0 auto;*!*/
  position: fixed;
  top: 20px;
  left: 30px;
  width: 20%;
}

.jdt {
  margin: 0 auto;
}

.el-icon-plus {
  width: 20px;
  height: 20px;
}

.test {
  width: 20px;
  height: 20px;
}
</style>








<style scoped>
.time-picker {
  margin-top: 15px;
}

.countdown {
  margin-top: 15px;
  color: #67C23A;
  font-weight: bold;
}

.time-tip {
  margin-top: 8px;
  font-size: 12px;
  color: #909399;
}
</style>









// WEBPACK FOOTER //
// src/components/login/quickappbiaodan.vue